import moment from "moment-timezone";

const TIMEZONE = "Asia/Jakarta";

export default function formatDateTimeWIB(
  value,
  format = "DD MMM YYYY",
) {
  if (!value) {
    return "-";
  }

  // Date only: dont need to convert with timezone
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return moment(value, "YYYY-MM-DD", true).format(format);
  }

  // Datetime without timezone: display original date
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(value)) {
    return moment(value).format(format);
  }

  // datetime with timezone format:
  // convert to WIB
  return moment(value).tz(TIMEZONE).format(format);
}
